<template>
  <Upselling
    @cta-click="onClick"
    class="p-6 max-w-[460px] border shadow-lg rounded-10 border-slate-300 dark:border-zinc-700"
    header="ADD A CTA BUTTON"
    :isFree="free"
    message="Add a “Call to Action” button to your content page to guide users toward desired actions. Customize the look and placement to ensure it’s on-brand and effective."
    cta="UPGRADE TO CREATE"
  />
</template>
<script setup lang="ts">
import Upselling from '@/components/Upselling.vue';
import { useViewerTrack, TrackEvents } from '@/modules/viewer/composables/useViewerTrack';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { storeToRefs } from 'pinia';

const orgStore = useOrganizationStore();
const { free } = storeToRefs(orgStore);
const { trackItemOwner } = useViewerTrack();

const onClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  trackItemOwner(!free?.value ? TrackEvents.CONTACT_US_CLICKED : TrackEvents.UPGRADE_CLICK).then(() => {
    window.location.assign('/account/plans');
  });
};
</script>
